import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { createDisposable, useCallbackRef } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { toArray, value, unwrap, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { tryHead } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { iterate } from "../fable_modules/fable-library-js.4.24.0/Seq.js";

export function useFeliz_React__React_useIntersect_Static_13EC530(root, rootMargin, threshold) {
    const patternInput = reactApi.useState(undefined);
    const patternInput_1 = reactApi.useState(undefined);
    const target = patternInput_1[0];
    const node_1 = useCallbackRef((node) => {
        patternInput_1[1](some(node));
    });
    const callBack = (entires, _arg) => {
        patternInput[1](tryHead(entires));
    };
    let observer;
    const initialValue = new IntersectionObserver(callBack, {root: unwrap(root), rootMargin: unwrap(rootMargin), threshold: unwrap(threshold)});
    observer = (reactApi.useRef(initialValue));
    useEffectWithDeps(() => {
        if (target == null) {
        }
        else {
            const t = value(target);
            try {
                observer.current.observe(t);
            }
            catch (matchValue) {
            }
        }
        return createDisposable(() => {
            observer.current.disconnect();
        });
    }, [target]);
    useEffectWithDeps(() => {
        let objectArg;
        observer.current.disconnect();
        observer.current = (new IntersectionObserver(callBack, {root: unwrap(root), rootMargin: unwrap(rootMargin), threshold: unwrap(threshold)}));
        try {
            iterate((objectArg = observer.current, (element) => {
                objectArg.observe(element);
            }), toArray(target));
        }
        catch (exn) {
            console.error(some(exn));
        }
        return createDisposable(() => {
            observer.current.disconnect();
        });
    }, [rootMargin, root, threshold]);
    return [node_1, patternInput[0]];
}

